module.exports = __webpack_public_path__ + "front/img/84.e89dd1e9.jpg";